module.exports = ["facebookPost","sqwizArticle","sqwizProduct","twitterTweet","informacijaProduct","informacijaPost","wordpressPost","woocommerceProduct"]


//////////////////
// WEBPACK FOOTER
// ./src/assets/configurations/mpe/acceptedTypes.json
// module id = fnCj
// module chunks = 53